// AUTO-GENERATED FILE — DO NOT EDIT MANUALLY
// Source: 08120344_ek1rpdsunumsistemi.xlsx / B-GRUP ÇALIŞMALARI

export const ADDITIONAL_GROUP_ACTIVITY_CATALOG_VERSION = "RPDH-ADDITIONAL-GROUP-V1";

export const ADDITIONAL_GROUP_ACTIVITY_CATALOG = [
  {
    "id": "class_guidance_preschool_kimden_nereden_ne_zaman_ve_nasil_yardim_isteyebilecegini_bilir",
    "officialLabel": "Kimden, nereden, ne zaman ve nasıl yardım isteyebileceğini bilir.",
    "mebbisCode": null,
    "serviceDomain": "preventive_developmental",
    "category": "class_guidance_preschool",
    "categoryLabel": "Sınıf Rehberlik Programı / Okul Öncesi",
    "audience": "student",
    "developmentArea": null,
    "schoolLevel": "preschool",
    "workMode": "group",
    "targetLinked": false,
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "workbook": "08120344_ek1rpdsunumsistemi.xlsx",
      "sheet": "RPDH SUNUM SİSTEMİ",
      "cells": [
        "N8"
      ]
    }
  },
  {
    "id": "class_guidance_primary_kimden_nereden_ne_zaman_ve_nasil_yardim_isteyebilecegini_bilir",
    "officialLabel": "Kimden, nereden, ne zaman ve nasıl yardım isteyebileceğini bilir.",
    "mebbisCode": null,
    "serviceDomain": "preventive_developmental",
    "category": "class_guidance_primary",
    "categoryLabel": "Sınıf Rehberlik Programı / İlkokul",
    "audience": "student",
    "developmentArea": null,
    "schoolLevel": "primary",
    "workMode": "group",
    "targetLinked": false,
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "workbook": "08120344_ek1rpdsunumsistemi.xlsx",
      "sheet": "RPDH SUNUM SİSTEMİ",
      "cells": [
        "O8"
      ]
    }
  },
  {
    "id": "class_guidance_primary_kisisel_guvenligi_icin_kisisel_alanlarin_gerekliligini_fark_eder",
    "officialLabel": "Kişisel güvenliği için kişisel alanların gerekliliğini fark eder.",
    "mebbisCode": null,
    "serviceDomain": "preventive_developmental",
    "category": "class_guidance_primary",
    "categoryLabel": "Sınıf Rehberlik Programı / İlkokul",
    "audience": "student",
    "developmentArea": null,
    "schoolLevel": "primary",
    "workMode": "group",
    "targetLinked": false,
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "workbook": "08120344_ek1rpdsunumsistemi.xlsx",
      "sheet": "RPDH SUNUM SİSTEMİ",
      "cells": [
        "O11"
      ]
    }
  },
  {
    "id": "class_guidance_middle_school_kimden_nereden_ne_zaman_ve_nasil_yardim_isteyebilecegini_bilir",
    "officialLabel": "Kimden, nereden, ne zaman ve nasıl yardım isteyebileceğini bilir.",
    "mebbisCode": null,
    "serviceDomain": "preventive_developmental",
    "category": "class_guidance_middle_school",
    "categoryLabel": "Sınıf Rehberlik Programı / Ortaokul",
    "audience": "student",
    "developmentArea": null,
    "schoolLevel": "middle_school",
    "workMode": "group",
    "targetLinked": false,
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "workbook": "08120344_ek1rpdsunumsistemi.xlsx",
      "sheet": "RPDH SUNUM SİSTEMİ",
      "cells": [
        "P8"
      ]
    }
  },
  {
    "id": "class_guidance_middle_school_sinavlara_iliskin_duygularini_aciklar",
    "officialLabel": "Sınavlara ilişkin duygularını açıklar.",
    "mebbisCode": null,
    "serviceDomain": "preventive_developmental",
    "category": "class_guidance_middle_school",
    "categoryLabel": "Sınıf Rehberlik Programı / Ortaokul",
    "audience": "student",
    "developmentArea": null,
    "schoolLevel": "middle_school",
    "workMode": "group",
    "targetLinked": false,
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "workbook": "08120344_ek1rpdsunumsistemi.xlsx",
      "sheet": "RPDH SUNUM SİSTEMİ",
      "cells": [
        "P11"
      ]
    }
  },
  {
    "id": "class_guidance_high_school_kimden_nereden_ne_zaman_ve_nasil_yardim_isteyebilecegini_bilir",
    "officialLabel": "Kimden, nereden, ne zaman ve nasıl yardım isteyebileceğini bilir.",
    "mebbisCode": null,
    "serviceDomain": "preventive_developmental",
    "category": "class_guidance_high_school",
    "categoryLabel": "Sınıf Rehberlik Programı / Ortaöğretim",
    "audience": "student",
    "developmentArea": null,
    "schoolLevel": "high_school",
    "workMode": "group",
    "targetLinked": false,
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "workbook": "08120344_ek1rpdsunumsistemi.xlsx",
      "sheet": "RPDH SUNUM SİSTEMİ",
      "cells": [
        "Q8"
      ]
    }
  },
  {
    "id": "class_guidance_high_school_ergen_ebeveyn_iliskilerini_degerlendirir",
    "officialLabel": "Ergen-ebeveyn ilişkilerini değerlendirir.",
    "mebbisCode": null,
    "serviceDomain": "preventive_developmental",
    "category": "class_guidance_high_school",
    "categoryLabel": "Sınıf Rehberlik Programı / Ortaöğretim",
    "audience": "student",
    "developmentArea": null,
    "schoolLevel": "high_school",
    "workMode": "group",
    "targetLinked": false,
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "workbook": "08120344_ek1rpdsunumsistemi.xlsx",
      "sheet": "RPDH SUNUM SİSTEMİ",
      "cells": [
        "Q11"
      ]
    }
  },
  {
    "id": "class_guidance_high_school_kisisel_sinirlarin_farkinda_olur",
    "officialLabel": "Kişisel sınırların farkında olur.",
    "mebbisCode": null,
    "serviceDomain": "preventive_developmental",
    "category": "class_guidance_high_school",
    "categoryLabel": "Sınıf Rehberlik Programı / Ortaöğretim",
    "audience": "student",
    "developmentArea": null,
    "schoolLevel": "high_school",
    "workMode": "group",
    "targetLinked": false,
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "workbook": "08120344_ek1rpdsunumsistemi.xlsx",
      "sheet": "RPDH SUNUM SİSTEMİ",
      "cells": [
        "Q13"
      ]
    }
  },
  {
    "id": "class_guidance_high_school_kendini_koruma_becerisi_kazanir",
    "officialLabel": "Kendini koruma becerisi kazanır.",
    "mebbisCode": null,
    "serviceDomain": "preventive_developmental",
    "category": "class_guidance_high_school",
    "categoryLabel": "Sınıf Rehberlik Programı / Ortaöğretim",
    "audience": "student",
    "developmentArea": null,
    "schoolLevel": "high_school",
    "workMode": "group",
    "targetLinked": false,
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "workbook": "08120344_ek1rpdsunumsistemi.xlsx",
      "sheet": "RPDH SUNUM SİSTEMİ",
      "cells": [
        "Q14"
      ]
    }
  },
  {
    "id": "individual_recognition_bana_kendini_anlat",
    "officialLabel": "Bana Kendini Anlat",
    "mebbisCode": null,
    "serviceDomain": "preventive_developmental",
    "category": "individual_recognition",
    "categoryLabel": "Bireyi Tanıma Çalışmaları",
    "audience": null,
    "developmentArea": null,
    "schoolLevel": null,
    "workMode": "group",
    "targetLinked": false,
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "workbook": "08120344_ek1rpdsunumsistemi.xlsx",
      "sheet": "RPDH SUNUM SİSTEMİ",
      "cells": [
        "R8"
      ]
    }
  },
  {
    "id": "individual_recognition_cocugumu_taniyorum",
    "officialLabel": "Çocuğumu Tanıyorum",
    "mebbisCode": null,
    "serviceDomain": "preventive_developmental",
    "category": "individual_recognition",
    "categoryLabel": "Bireyi Tanıma Çalışmaları",
    "audience": null,
    "developmentArea": null,
    "schoolLevel": null,
    "workMode": "group",
    "targetLinked": false,
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "workbook": "08120344_ek1rpdsunumsistemi.xlsx",
      "sheet": "RPDH SUNUM SİSTEMİ",
      "cells": [
        "R9"
      ]
    }
  },
  {
    "id": "individual_recognition_devamsizlik_nedenleri_anketi",
    "officialLabel": "Devamsızlık Nedenleri Anketi",
    "mebbisCode": null,
    "serviceDomain": "preventive_developmental",
    "category": "individual_recognition",
    "categoryLabel": "Bireyi Tanıma Çalışmaları",
    "audience": null,
    "developmentArea": null,
    "schoolLevel": null,
    "workMode": "group",
    "targetLinked": false,
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "workbook": "08120344_ek1rpdsunumsistemi.xlsx",
      "sheet": "RPDH SUNUM SİSTEMİ",
      "cells": [
        "R10"
      ]
    }
  },
  {
    "id": "individual_recognition_kendimi_taniyorum",
    "officialLabel": "Kendimi Tanıyorum",
    "mebbisCode": null,
    "serviceDomain": "preventive_developmental",
    "category": "individual_recognition",
    "categoryLabel": "Bireyi Tanıma Çalışmaları",
    "audience": null,
    "developmentArea": null,
    "schoolLevel": null,
    "workMode": "group",
    "targetLinked": false,
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "workbook": "08120344_ek1rpdsunumsistemi.xlsx",
      "sheet": "RPDH SUNUM SİSTEMİ",
      "cells": [
        "R11"
      ]
    }
  },
  {
    "id": "individual_recognition_kimdir_bu",
    "officialLabel": "Kimdir Bu",
    "mebbisCode": null,
    "serviceDomain": "preventive_developmental",
    "category": "individual_recognition",
    "categoryLabel": "Bireyi Tanıma Çalışmaları",
    "audience": null,
    "developmentArea": null,
    "schoolLevel": null,
    "workMode": "group",
    "targetLinked": false,
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "workbook": "08120344_ek1rpdsunumsistemi.xlsx",
      "sheet": "RPDH SUNUM SİSTEMİ",
      "cells": [
        "R12"
      ]
    }
  },
  {
    "id": "individual_recognition_kime_gore_ben_neyim",
    "officialLabel": "Kime Göre Ben Neyim",
    "mebbisCode": null,
    "serviceDomain": "preventive_developmental",
    "category": "individual_recognition",
    "categoryLabel": "Bireyi Tanıma Çalışmaları",
    "audience": null,
    "developmentArea": null,
    "schoolLevel": null,
    "workMode": "group",
    "targetLinked": false,
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "workbook": "08120344_ek1rpdsunumsistemi.xlsx",
      "sheet": "RPDH SUNUM SİSTEMİ",
      "cells": [
        "R13"
      ]
    }
  },
  {
    "id": "individual_recognition_okul_risk_haritasi",
    "officialLabel": "Okul Risk Haritası",
    "mebbisCode": null,
    "serviceDomain": "preventive_developmental",
    "category": "individual_recognition",
    "categoryLabel": "Bireyi Tanıma Çalışmaları",
    "audience": null,
    "developmentArea": null,
    "schoolLevel": null,
    "workMode": "group",
    "targetLinked": false,
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "workbook": "08120344_ek1rpdsunumsistemi.xlsx",
      "sheet": "RPDH SUNUM SİSTEMİ",
      "cells": [
        "R14"
      ]
    }
  },
  {
    "id": "individual_recognition_ogrenci_bilgi_formu",
    "officialLabel": "Öğrenci Bilgi Formu",
    "mebbisCode": null,
    "serviceDomain": "preventive_developmental",
    "category": "individual_recognition",
    "categoryLabel": "Bireyi Tanıma Çalışmaları",
    "audience": null,
    "developmentArea": null,
    "schoolLevel": null,
    "workMode": "group",
    "targetLinked": false,
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "workbook": "08120344_ek1rpdsunumsistemi.xlsx",
      "sheet": "RPDH SUNUM SİSTEMİ",
      "cells": [
        "R15"
      ]
    }
  },
  {
    "id": "individual_recognition_riba_ilkokul_ogrenci_formu",
    "officialLabel": "RİBA (İlkokul-Öğrenci Formu)",
    "mebbisCode": null,
    "serviceDomain": "preventive_developmental",
    "category": "individual_recognition",
    "categoryLabel": "Bireyi Tanıma Çalışmaları",
    "audience": null,
    "developmentArea": null,
    "schoolLevel": null,
    "workMode": "group",
    "targetLinked": false,
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "workbook": "08120344_ek1rpdsunumsistemi.xlsx",
      "sheet": "RPDH SUNUM SİSTEMİ",
      "cells": [
        "R16"
      ]
    }
  },
  {
    "id": "individual_recognition_riba_ortaokul_ogrenci_formu",
    "officialLabel": "RİBA (Ortaokul-Öğrenci Formu)",
    "mebbisCode": null,
    "serviceDomain": "preventive_developmental",
    "category": "individual_recognition",
    "categoryLabel": "Bireyi Tanıma Çalışmaları",
    "audience": null,
    "developmentArea": null,
    "schoolLevel": null,
    "workMode": "group",
    "targetLinked": false,
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "workbook": "08120344_ek1rpdsunumsistemi.xlsx",
      "sheet": "RPDH SUNUM SİSTEMİ",
      "cells": [
        "R17"
      ]
    }
  },
  {
    "id": "individual_recognition_riba_lise_ogrenci_formu",
    "officialLabel": "RİBA (Lise-Öğrenci Formu)",
    "mebbisCode": null,
    "serviceDomain": "preventive_developmental",
    "category": "individual_recognition",
    "categoryLabel": "Bireyi Tanıma Çalışmaları",
    "audience": null,
    "developmentArea": null,
    "schoolLevel": null,
    "workMode": "group",
    "targetLinked": false,
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "workbook": "08120344_ek1rpdsunumsistemi.xlsx",
      "sheet": "RPDH SUNUM SİSTEMİ",
      "cells": [
        "R18"
      ]
    }
  },
  {
    "id": "individual_recognition_riba_okuloncesi_ogretmen_formu",
    "officialLabel": "RİBA (Okulöncesi-Öğretmen Formu)",
    "mebbisCode": null,
    "serviceDomain": "preventive_developmental",
    "category": "individual_recognition",
    "categoryLabel": "Bireyi Tanıma Çalışmaları",
    "audience": "teacher",
    "developmentArea": null,
    "schoolLevel": null,
    "workMode": "group",
    "targetLinked": false,
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "workbook": "08120344_ek1rpdsunumsistemi.xlsx",
      "sheet": "RPDH SUNUM SİSTEMİ",
      "cells": [
        "R19"
      ]
    }
  },
  {
    "id": "individual_recognition_riba_ilkokul_ogretmen_formu",
    "officialLabel": "RİBA (İlkokul-Öğretmen Formu)",
    "mebbisCode": null,
    "serviceDomain": "preventive_developmental",
    "category": "individual_recognition",
    "categoryLabel": "Bireyi Tanıma Çalışmaları",
    "audience": "teacher",
    "developmentArea": null,
    "schoolLevel": null,
    "workMode": "group",
    "targetLinked": false,
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "workbook": "08120344_ek1rpdsunumsistemi.xlsx",
      "sheet": "RPDH SUNUM SİSTEMİ",
      "cells": [
        "R20"
      ]
    }
  },
  {
    "id": "individual_recognition_riba_ortaokul_ogretmen_formu",
    "officialLabel": "RİBA(Ortaokul-Öğretmen Formu)",
    "mebbisCode": null,
    "serviceDomain": "preventive_developmental",
    "category": "individual_recognition",
    "categoryLabel": "Bireyi Tanıma Çalışmaları",
    "audience": "teacher",
    "developmentArea": null,
    "schoolLevel": null,
    "workMode": "group",
    "targetLinked": false,
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "workbook": "08120344_ek1rpdsunumsistemi.xlsx",
      "sheet": "RPDH SUNUM SİSTEMİ",
      "cells": [
        "R21"
      ]
    }
  },
  {
    "id": "individual_recognition_riba_lise_ogretmen_formu",
    "officialLabel": "RİBA (Lise-Öğretmen Formu)",
    "mebbisCode": null,
    "serviceDomain": "preventive_developmental",
    "category": "individual_recognition",
    "categoryLabel": "Bireyi Tanıma Çalışmaları",
    "audience": "teacher",
    "developmentArea": null,
    "schoolLevel": null,
    "workMode": "group",
    "targetLinked": false,
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "workbook": "08120344_ek1rpdsunumsistemi.xlsx",
      "sheet": "RPDH SUNUM SİSTEMİ",
      "cells": [
        "R22"
      ]
    }
  },
  {
    "id": "individual_recognition_riba_okuloncesi_veli_formu",
    "officialLabel": "RİBA (Okulöncesi-Veli Formu)",
    "mebbisCode": null,
    "serviceDomain": "preventive_developmental",
    "category": "individual_recognition",
    "categoryLabel": "Bireyi Tanıma Çalışmaları",
    "audience": "parent",
    "developmentArea": null,
    "schoolLevel": null,
    "workMode": "group",
    "targetLinked": false,
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "workbook": "08120344_ek1rpdsunumsistemi.xlsx",
      "sheet": "RPDH SUNUM SİSTEMİ",
      "cells": [
        "R23"
      ]
    }
  },
  {
    "id": "individual_recognition_riba_ilkokul_veli_formu",
    "officialLabel": "RİBA (İlkokul-Veli Formu)",
    "mebbisCode": null,
    "serviceDomain": "preventive_developmental",
    "category": "individual_recognition",
    "categoryLabel": "Bireyi Tanıma Çalışmaları",
    "audience": "parent",
    "developmentArea": null,
    "schoolLevel": null,
    "workMode": "group",
    "targetLinked": false,
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "workbook": "08120344_ek1rpdsunumsistemi.xlsx",
      "sheet": "RPDH SUNUM SİSTEMİ",
      "cells": [
        "R24"
      ]
    }
  },
  {
    "id": "individual_recognition_riba_ortaokul_veli_formu",
    "officialLabel": "RİBA (Ortaokul-Veli Formu)",
    "mebbisCode": null,
    "serviceDomain": "preventive_developmental",
    "category": "individual_recognition",
    "categoryLabel": "Bireyi Tanıma Çalışmaları",
    "audience": "parent",
    "developmentArea": null,
    "schoolLevel": null,
    "workMode": "group",
    "targetLinked": false,
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "workbook": "08120344_ek1rpdsunumsistemi.xlsx",
      "sheet": "RPDH SUNUM SİSTEMİ",
      "cells": [
        "R25"
      ]
    }
  },
  {
    "id": "individual_recognition_riba_lise_veli_formu",
    "officialLabel": "RİBA (Lise-Veli Formu)",
    "mebbisCode": null,
    "serviceDomain": "preventive_developmental",
    "category": "individual_recognition",
    "categoryLabel": "Bireyi Tanıma Çalışmaları",
    "audience": "parent",
    "developmentArea": null,
    "schoolLevel": null,
    "workMode": "group",
    "targetLinked": false,
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "workbook": "08120344_ek1rpdsunumsistemi.xlsx",
      "sheet": "RPDH SUNUM SİSTEMİ",
      "cells": [
        "R26"
      ]
    }
  },
  {
    "id": "individual_recognition_sinif_risk_haritasi",
    "officialLabel": "Sınıf Risk Haritası",
    "mebbisCode": null,
    "serviceDomain": "preventive_developmental",
    "category": "individual_recognition",
    "categoryLabel": "Bireyi Tanıma Çalışmaları",
    "audience": null,
    "developmentArea": null,
    "schoolLevel": null,
    "workMode": "group",
    "targetLinked": false,
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "workbook": "08120344_ek1rpdsunumsistemi.xlsx",
      "sheet": "RPDH SUNUM SİSTEMİ",
      "cells": [
        "R27"
      ]
    }
  },
  {
    "id": "individual_recognition_snellen_testi",
    "officialLabel": "Snellen Testi",
    "mebbisCode": null,
    "serviceDomain": "preventive_developmental",
    "category": "individual_recognition",
    "categoryLabel": "Bireyi Tanıma Çalışmaları",
    "audience": null,
    "developmentArea": null,
    "schoolLevel": null,
    "workMode": "group",
    "targetLinked": false,
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "workbook": "08120344_ek1rpdsunumsistemi.xlsx",
      "sheet": "RPDH SUNUM SİSTEMİ",
      "cells": [
        "R28"
      ]
    }
  },
  {
    "id": "individual_recognition_sosyometri",
    "officialLabel": "Sosyometri",
    "mebbisCode": null,
    "serviceDomain": "preventive_developmental",
    "category": "individual_recognition",
    "categoryLabel": "Bireyi Tanıma Çalışmaları",
    "audience": null,
    "developmentArea": null,
    "schoolLevel": null,
    "workMode": "group",
    "targetLinked": false,
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "workbook": "08120344_ek1rpdsunumsistemi.xlsx",
      "sheet": "RPDH SUNUM SİSTEMİ",
      "cells": [
        "R29"
      ]
    }
  },
  {
    "id": "individual_recognition_siddet_algisi_anketi",
    "officialLabel": "Şiddet Algısı Anketi",
    "mebbisCode": null,
    "serviceDomain": "preventive_developmental",
    "category": "individual_recognition",
    "categoryLabel": "Bireyi Tanıma Çalışmaları",
    "audience": null,
    "developmentArea": null,
    "schoolLevel": null,
    "workMode": "group",
    "targetLinked": false,
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "workbook": "08120344_ek1rpdsunumsistemi.xlsx",
      "sheet": "RPDH SUNUM SİSTEMİ",
      "cells": [
        "R30"
      ]
    }
  },
  {
    "id": "individual_recognition_siddet_algisi_anketi_veli",
    "officialLabel": "Şiddet Algısı Anketi (Veli)",
    "mebbisCode": null,
    "serviceDomain": "preventive_developmental",
    "category": "individual_recognition",
    "categoryLabel": "Bireyi Tanıma Çalışmaları",
    "audience": "parent",
    "developmentArea": null,
    "schoolLevel": null,
    "workMode": "group",
    "targetLinked": false,
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "workbook": "08120344_ek1rpdsunumsistemi.xlsx",
      "sheet": "RPDH SUNUM SİSTEMİ",
      "cells": [
        "R31"
      ]
    }
  },
  {
    "id": "individual_recognition_siddet_algisi_an_ogretmen",
    "officialLabel": "Şiddet Algısı An. (Öğretmen)",
    "mebbisCode": null,
    "serviceDomain": "preventive_developmental",
    "category": "individual_recognition",
    "categoryLabel": "Bireyi Tanıma Çalışmaları",
    "audience": "teacher",
    "developmentArea": null,
    "schoolLevel": null,
    "workMode": "group",
    "targetLinked": false,
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "workbook": "08120344_ek1rpdsunumsistemi.xlsx",
      "sheet": "RPDH SUNUM SİSTEMİ",
      "cells": [
        "R32"
      ]
    }
  },
  {
    "id": "individual_recognition_siddet_mesruiyeti_anketi",
    "officialLabel": "Şiddet Meşruiyeti Anketi",
    "mebbisCode": null,
    "serviceDomain": "preventive_developmental",
    "category": "individual_recognition",
    "categoryLabel": "Bireyi Tanıma Çalışmaları",
    "audience": null,
    "developmentArea": null,
    "schoolLevel": null,
    "workMode": "group",
    "targetLinked": false,
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "workbook": "08120344_ek1rpdsunumsistemi.xlsx",
      "sheet": "RPDH SUNUM SİSTEMİ",
      "cells": [
        "R33"
      ]
    }
  },
  {
    "id": "individual_recognition_siddet_mesruiyeti_anketi_ogretmen_4_6_7_12_sinif",
    "officialLabel": "Şiddet Meşruiyeti Anketi (Öğretmen 4-6/7-12.Sınıf)",
    "mebbisCode": null,
    "serviceDomain": "preventive_developmental",
    "category": "individual_recognition",
    "categoryLabel": "Bireyi Tanıma Çalışmaları",
    "audience": "teacher",
    "developmentArea": null,
    "schoolLevel": null,
    "workMode": "group",
    "targetLinked": false,
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "workbook": "08120344_ek1rpdsunumsistemi.xlsx",
      "sheet": "RPDH SUNUM SİSTEMİ",
      "cells": [
        "R34",
        "R35"
      ]
    }
  },
  {
    "id": "individual_recognition_siddet_mesruiyeti_ank_veli",
    "officialLabel": "Şiddet Meşruiyeti Ank. (Veli)",
    "mebbisCode": null,
    "serviceDomain": "preventive_developmental",
    "category": "individual_recognition",
    "categoryLabel": "Bireyi Tanıma Çalışmaları",
    "audience": "parent",
    "developmentArea": null,
    "schoolLevel": null,
    "workMode": "group",
    "targetLinked": false,
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "workbook": "08120344_ek1rpdsunumsistemi.xlsx",
      "sheet": "RPDH SUNUM SİSTEMİ",
      "cells": [
        "R36"
      ]
    }
  },
  {
    "id": "individual_recognition_siddet_sikligi_anketi",
    "officialLabel": "Şiddet Sıklığı Anketi",
    "mebbisCode": null,
    "serviceDomain": "preventive_developmental",
    "category": "individual_recognition",
    "categoryLabel": "Bireyi Tanıma Çalışmaları",
    "audience": null,
    "developmentArea": null,
    "schoolLevel": null,
    "workMode": "group",
    "targetLinked": false,
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "workbook": "08120344_ek1rpdsunumsistemi.xlsx",
      "sheet": "RPDH SUNUM SİSTEMİ",
      "cells": [
        "R37"
      ]
    }
  },
  {
    "id": "individual_recognition_siddet_sikligi_ank_ogretmen",
    "officialLabel": "Şiddet Sıklığı Ank. (Öğretmen)",
    "mebbisCode": null,
    "serviceDomain": "preventive_developmental",
    "category": "individual_recognition",
    "categoryLabel": "Bireyi Tanıma Çalışmaları",
    "audience": "teacher",
    "developmentArea": null,
    "schoolLevel": null,
    "workMode": "group",
    "targetLinked": false,
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "workbook": "08120344_ek1rpdsunumsistemi.xlsx",
      "sheet": "RPDH SUNUM SİSTEMİ",
      "cells": [
        "R38"
      ]
    }
  },
  {
    "id": "individual_recognition_siddet_sikligi_ank_veli",
    "officialLabel": "Şiddet Sıklığı Ank. (Veli)",
    "mebbisCode": null,
    "serviceDomain": "preventive_developmental",
    "category": "individual_recognition",
    "categoryLabel": "Bireyi Tanıma Çalışmaları",
    "audience": "parent",
    "developmentArea": null,
    "schoolLevel": null,
    "workMode": "group",
    "targetLinked": false,
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "workbook": "08120344_ek1rpdsunumsistemi.xlsx",
      "sheet": "RPDH SUNUM SİSTEMİ",
      "cells": [
        "R39"
      ]
    }
  },
  {
    "id": "individual_recognition_verimli_ders_calisma_kontrol_listesi",
    "officialLabel": "Verimli Ders Çalışma Kontrol Listesi",
    "mebbisCode": null,
    "serviceDomain": "preventive_developmental",
    "category": "individual_recognition",
    "categoryLabel": "Bireyi Tanıma Çalışmaları",
    "audience": null,
    "developmentArea": null,
    "schoolLevel": null,
    "workMode": "group",
    "targetLinked": false,
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "workbook": "08120344_ek1rpdsunumsistemi.xlsx",
      "sheet": "RPDH SUNUM SİSTEMİ",
      "cells": [
        "R40"
      ]
    }
  },
  {
    "id": "individual_recognition_yasam_pencerem",
    "officialLabel": "Yaşam Pencerem",
    "mebbisCode": null,
    "serviceDomain": "preventive_developmental",
    "category": "individual_recognition",
    "categoryLabel": "Bireyi Tanıma Çalışmaları",
    "audience": null,
    "developmentArea": null,
    "schoolLevel": null,
    "workMode": "group",
    "targetLinked": false,
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "workbook": "08120344_ek1rpdsunumsistemi.xlsx",
      "sheet": "RPDH SUNUM SİSTEMİ",
      "cells": [
        "R42"
      ]
    }
  },
  {
    "id": "individual_recognition_diger",
    "officialLabel": "Diğer",
    "mebbisCode": null,
    "serviceDomain": "preventive_developmental",
    "category": "individual_recognition",
    "categoryLabel": "Bireyi Tanıma Çalışmaları",
    "audience": null,
    "developmentArea": null,
    "schoolLevel": null,
    "workMode": "group",
    "targetLinked": false,
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "workbook": "08120344_ek1rpdsunumsistemi.xlsx",
      "sheet": "RPDH SUNUM SİSTEMİ",
      "cells": [
        "R43"
      ]
    }
  },
  {
    "id": "orientation_monitoring_alan_dal_tercihleri",
    "officialLabel": "Alan/Dal Tercihleri",
    "mebbisCode": null,
    "serviceDomain": "preventive_developmental",
    "category": "orientation_monitoring",
    "categoryLabel": "Yöneltme ve İzleme",
    "audience": "student",
    "developmentArea": null,
    "schoolLevel": null,
    "workMode": "group",
    "targetLinked": false,
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "workbook": "08120344_ek1rpdsunumsistemi.xlsx",
      "sheet": "RPDH SUNUM SİSTEMİ",
      "cells": [
        "W8"
      ]
    }
  },
  {
    "id": "orientation_monitoring_secmeli_ders",
    "officialLabel": "Seçmeli Ders",
    "mebbisCode": null,
    "serviceDomain": "preventive_developmental",
    "category": "orientation_monitoring",
    "categoryLabel": "Yöneltme ve İzleme",
    "audience": "student",
    "developmentArea": null,
    "schoolLevel": null,
    "workMode": "group",
    "targetLinked": false,
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "workbook": "08120344_ek1rpdsunumsistemi.xlsx",
      "sheet": "RPDH SUNUM SİSTEMİ",
      "cells": [
        "W9"
      ]
    }
  },
  {
    "id": "orientation_monitoring_sosyal_kulupler",
    "officialLabel": "Sosyal Kulüpler",
    "mebbisCode": null,
    "serviceDomain": "preventive_developmental",
    "category": "orientation_monitoring",
    "categoryLabel": "Yöneltme ve İzleme",
    "audience": "student",
    "developmentArea": null,
    "schoolLevel": null,
    "workMode": "group",
    "targetLinked": false,
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "workbook": "08120344_ek1rpdsunumsistemi.xlsx",
      "sheet": "RPDH SUNUM SİSTEMİ",
      "cells": [
        "W10"
      ]
    }
  },
  {
    "id": "orientation_monitoring_sosyal_ve_kulturel_faaliyetler",
    "officialLabel": "Sosyal ve Kültürel Faaliyetler",
    "mebbisCode": null,
    "serviceDomain": "preventive_developmental",
    "category": "orientation_monitoring",
    "categoryLabel": "Yöneltme ve İzleme",
    "audience": "student",
    "developmentArea": null,
    "schoolLevel": null,
    "workMode": "group",
    "targetLinked": false,
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "workbook": "08120344_ek1rpdsunumsistemi.xlsx",
      "sheet": "RPDH SUNUM SİSTEMİ",
      "cells": [
        "W11"
      ]
    }
  },
  {
    "id": "group_counseling_grupla_psikolojik_danisma",
    "officialLabel": "Grupla Psikolojik Danışma",
    "mebbisCode": null,
    "serviceDomain": "remedial",
    "category": "group_counseling",
    "categoryLabel": "Grupla Psikolojik Danışma",
    "audience": "student",
    "developmentArea": null,
    "schoolLevel": null,
    "workMode": "group",
    "targetLinked": false,
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "workbook": "08120344_ek1rpdsunumsistemi.xlsx",
      "sheet": "RPDH SUNUM SİSTEMİ",
      "cells": [
        "X8"
      ]
    }
  },
  {
    "id": "group_counseling_zorlayici_yasam_olaylari_sonrasi_sinif_temelli_mudehale_stm_programi",
    "officialLabel": "Zorlayıcı Yaşam Olayları Sonrası Sınıf Temelli Müdehale (STM) Programı",
    "mebbisCode": null,
    "serviceDomain": "remedial",
    "category": "group_counseling",
    "categoryLabel": "Grupla Psikolojik Danışma",
    "audience": "student",
    "developmentArea": null,
    "schoolLevel": null,
    "workMode": "group",
    "targetLinked": false,
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "workbook": "08120344_ek1rpdsunumsistemi.xlsx",
      "sheet": "RPDH SUNUM SİSTEMİ",
      "cells": [
        "X9"
      ]
    }
  },
  {
    "id": "group_counseling_travma_sonrasi_grup_temelli_mudahale_programi_ts_gtm",
    "officialLabel": "Travma Sonrası Grup Temelli Müdahale Programı (TS-GTM)",
    "mebbisCode": null,
    "serviceDomain": "remedial",
    "category": "group_counseling",
    "categoryLabel": "Grupla Psikolojik Danışma",
    "audience": "student",
    "developmentArea": null,
    "schoolLevel": null,
    "workMode": "group",
    "targetLinked": false,
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "workbook": "08120344_ek1rpdsunumsistemi.xlsx",
      "sheet": "RPDH SUNUM SİSTEMİ",
      "cells": [
        "X11"
      ]
    }
  },
  {
    "id": "group_counseling_degisen_ben_grupla_mud_programi",
    "officialLabel": "Değişen Ben- Grupla Müd. Programı",
    "mebbisCode": null,
    "serviceDomain": "remedial",
    "category": "group_counseling",
    "categoryLabel": "Grupla Psikolojik Danışma",
    "audience": "student",
    "developmentArea": null,
    "schoolLevel": null,
    "workMode": "group",
    "targetLinked": false,
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "workbook": "08120344_ek1rpdsunumsistemi.xlsx",
      "sheet": "RPDH SUNUM SİSTEMİ",
      "cells": [
        "X13"
      ]
    }
  },
  {
    "id": "psychosocial_intervention_akran_zorbaligi",
    "officialLabel": "Akran Zorbalığı",
    "mebbisCode": null,
    "serviceDomain": "remedial",
    "category": "psychosocial_intervention",
    "categoryLabel": "Psikososyal Müdahale",
    "audience": "student",
    "developmentArea": null,
    "schoolLevel": null,
    "workMode": "group",
    "targetLinked": false,
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "workbook": "08120344_ek1rpdsunumsistemi.xlsx",
      "sheet": "RPDH SUNUM SİSTEMİ",
      "cells": [
        "Y8"
      ]
    }
  },
  {
    "id": "psychosocial_intervention_siber_zorbalik",
    "officialLabel": "Siber Zorbalık",
    "mebbisCode": null,
    "serviceDomain": "remedial",
    "category": "psychosocial_intervention",
    "categoryLabel": "Psikososyal Müdahale",
    "audience": "student",
    "developmentArea": null,
    "schoolLevel": null,
    "workMode": "group",
    "targetLinked": false,
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "workbook": "08120344_ek1rpdsunumsistemi.xlsx",
      "sheet": "RPDH SUNUM SİSTEMİ",
      "cells": [
        "Y9"
      ]
    }
  },
  {
    "id": "psychosocial_intervention_psikososyal_destek_cinsel_istismar",
    "officialLabel": "Psikososyal Destek-CİNSEL İSTİSMAR",
    "mebbisCode": null,
    "serviceDomain": "remedial",
    "category": "psychosocial_intervention",
    "categoryLabel": "Psikososyal Müdahale",
    "audience": "student",
    "developmentArea": null,
    "schoolLevel": null,
    "workMode": "group",
    "targetLinked": false,
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "workbook": "08120344_ek1rpdsunumsistemi.xlsx",
      "sheet": "RPDH SUNUM SİSTEMİ",
      "cells": [
        "Y10"
      ]
    }
  },
  {
    "id": "psychosocial_intervention_psikososyal_destek_cig",
    "officialLabel": "Psikososyal Destek-ÇIĞ",
    "mebbisCode": null,
    "serviceDomain": "remedial",
    "category": "psychosocial_intervention",
    "categoryLabel": "Psikososyal Müdahale",
    "audience": "student",
    "developmentArea": null,
    "schoolLevel": null,
    "workMode": "group",
    "targetLinked": false,
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "workbook": "08120344_ek1rpdsunumsistemi.xlsx",
      "sheet": "RPDH SUNUM SİSTEMİ",
      "cells": [
        "Y12"
      ]
    }
  },
  {
    "id": "psychosocial_intervention_psikososyal_destek_deprem",
    "officialLabel": "Psikososyal Destek-DEPREM",
    "mebbisCode": null,
    "serviceDomain": "remedial",
    "category": "psychosocial_intervention",
    "categoryLabel": "Psikososyal Müdahale",
    "audience": "student",
    "developmentArea": null,
    "schoolLevel": null,
    "workMode": "group",
    "targetLinked": false,
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "workbook": "08120344_ek1rpdsunumsistemi.xlsx",
      "sheet": "RPDH SUNUM SİSTEMİ",
      "cells": [
        "Y13"
      ]
    }
  },
  {
    "id": "psychosocial_intervention_psikososyal_destek_goc",
    "officialLabel": "Psikososyal Destek-GÖÇ",
    "mebbisCode": null,
    "serviceDomain": "remedial",
    "category": "psychosocial_intervention",
    "categoryLabel": "Psikososyal Müdahale",
    "audience": "student",
    "developmentArea": null,
    "schoolLevel": null,
    "workMode": "group",
    "targetLinked": false,
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "workbook": "08120344_ek1rpdsunumsistemi.xlsx",
      "sheet": "RPDH SUNUM SİSTEMİ",
      "cells": [
        "Y14"
      ]
    }
  },
  {
    "id": "psychosocial_intervention_psikososyal_destek_intihar",
    "officialLabel": "Psikososyal Destek-İNTİHAR",
    "mebbisCode": null,
    "serviceDomain": "remedial",
    "category": "psychosocial_intervention",
    "categoryLabel": "Psikososyal Müdahale",
    "audience": "student",
    "developmentArea": null,
    "schoolLevel": null,
    "workMode": "group",
    "targetLinked": false,
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "workbook": "08120344_ek1rpdsunumsistemi.xlsx",
      "sheet": "RPDH SUNUM SİSTEMİ",
      "cells": [
        "Y15"
      ]
    }
  },
  {
    "id": "psychosocial_intervention_psikososyal_destek_maden_kazasi",
    "officialLabel": "Psikososyal Destek-MADEN KAZASI",
    "mebbisCode": null,
    "serviceDomain": "remedial",
    "category": "psychosocial_intervention",
    "categoryLabel": "Psikososyal Müdahale",
    "audience": "student",
    "developmentArea": null,
    "schoolLevel": null,
    "workMode": "group",
    "targetLinked": false,
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "workbook": "08120344_ek1rpdsunumsistemi.xlsx",
      "sheet": "RPDH SUNUM SİSTEMİ",
      "cells": [
        "Y16"
      ]
    }
  },
  {
    "id": "psychosocial_intervention_psikososyal_destek_salgin_hastalik",
    "officialLabel": "Psikososyal Destek-SALGIN HASTALIK",
    "mebbisCode": null,
    "serviceDomain": "remedial",
    "category": "psychosocial_intervention",
    "categoryLabel": "Psikososyal Müdahale",
    "audience": "student",
    "developmentArea": null,
    "schoolLevel": null,
    "workMode": "group",
    "targetLinked": false,
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "workbook": "08120344_ek1rpdsunumsistemi.xlsx",
      "sheet": "RPDH SUNUM SİSTEMİ",
      "cells": [
        "Y18"
      ]
    }
  },
  {
    "id": "psychosocial_intervention_psikososyal_destek_sel",
    "officialLabel": "Psikososyal Destek-SEL",
    "mebbisCode": null,
    "serviceDomain": "remedial",
    "category": "psychosocial_intervention",
    "categoryLabel": "Psikososyal Müdahale",
    "audience": "student",
    "developmentArea": null,
    "schoolLevel": null,
    "workMode": "group",
    "targetLinked": false,
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "workbook": "08120344_ek1rpdsunumsistemi.xlsx",
      "sheet": "RPDH SUNUM SİSTEMİ",
      "cells": [
        "Y20"
      ]
    }
  },
  {
    "id": "psychosocial_intervention_psikososyal_destek_teror",
    "officialLabel": "Psikososyal Destek-TERÖR",
    "mebbisCode": null,
    "serviceDomain": "remedial",
    "category": "psychosocial_intervention",
    "categoryLabel": "Psikososyal Müdahale",
    "audience": "student",
    "developmentArea": null,
    "schoolLevel": null,
    "workMode": "group",
    "targetLinked": false,
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "workbook": "08120344_ek1rpdsunumsistemi.xlsx",
      "sheet": "RPDH SUNUM SİSTEMİ",
      "cells": [
        "Y21"
      ]
    }
  },
  {
    "id": "psychosocial_intervention_psikososyal_destek_yangin",
    "officialLabel": "Psikososyal Destek-YANGIN",
    "mebbisCode": null,
    "serviceDomain": "remedial",
    "category": "psychosocial_intervention",
    "categoryLabel": "Psikososyal Müdahale",
    "audience": "student",
    "developmentArea": null,
    "schoolLevel": null,
    "workMode": "group",
    "targetLinked": false,
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "workbook": "08120344_ek1rpdsunumsistemi.xlsx",
      "sheet": "RPDH SUNUM SİSTEMİ",
      "cells": [
        "Y22"
      ]
    }
  },
  {
    "id": "psychosocial_intervention_psikososyal_destek_yas",
    "officialLabel": "Psikososyal Destek-YAS",
    "mebbisCode": null,
    "serviceDomain": "remedial",
    "category": "psychosocial_intervention",
    "categoryLabel": "Psikososyal Müdahale",
    "audience": "student",
    "developmentArea": null,
    "schoolLevel": null,
    "workMode": "group",
    "targetLinked": false,
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "workbook": "08120344_ek1rpdsunumsistemi.xlsx",
      "sheet": "RPDH SUNUM SİSTEMİ",
      "cells": [
        "Y23"
      ]
    }
  },
  {
    "id": "consultancy_other_alkol_bagimliligini_onleme",
    "officialLabel": "Alkol Bağımlılığını Önleme",
    "mebbisCode": null,
    "serviceDomain": "support",
    "category": "consultancy_other",
    "categoryLabel": "Müşavirlik / Diğer Kişilere Yönelik",
    "audience": "other",
    "developmentArea": null,
    "schoolLevel": null,
    "workMode": "group",
    "targetLinked": false,
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "workbook": "08120344_ek1rpdsunumsistemi.xlsx",
      "sheet": "RPDH SUNUM SİSTEMİ",
      "cells": [
        "AD8"
      ]
    }
  },
  {
    "id": "consultancy_other_bagimlilikla_mucadele",
    "officialLabel": "Bağımlılıkla Mücadele",
    "mebbisCode": null,
    "serviceDomain": "support",
    "category": "consultancy_other",
    "categoryLabel": "Müşavirlik / Diğer Kişilere Yönelik",
    "audience": "other",
    "developmentArea": null,
    "schoolLevel": null,
    "workMode": "group",
    "targetLinked": false,
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "workbook": "08120344_ek1rpdsunumsistemi.xlsx",
      "sheet": "RPDH SUNUM SİSTEMİ",
      "cells": [
        "AD9"
      ]
    }
  },
  {
    "id": "consultancy_other_cocuk_ve_ergenlerin_gelisim_ozellikleri",
    "officialLabel": "Çocuk ve Ergenlerin Gelişim Özellikleri",
    "mebbisCode": null,
    "serviceDomain": "support",
    "category": "consultancy_other",
    "categoryLabel": "Müşavirlik / Diğer Kişilere Yönelik",
    "audience": "other",
    "developmentArea": null,
    "schoolLevel": null,
    "workMode": "group",
    "targetLinked": false,
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "workbook": "08120344_ek1rpdsunumsistemi.xlsx",
      "sheet": "RPDH SUNUM SİSTEMİ",
      "cells": [
        "AD10",
        "AD11"
      ]
    }
  },
  {
    "id": "consultancy_other_egitim_kurumunun_tanitimi",
    "officialLabel": "Eğitim Kurumunun Tanıtımı",
    "mebbisCode": null,
    "serviceDomain": "support",
    "category": "consultancy_other",
    "categoryLabel": "Müşavirlik / Diğer Kişilere Yönelik",
    "audience": "other",
    "developmentArea": null,
    "schoolLevel": null,
    "workMode": "group",
    "targetLinked": false,
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "workbook": "08120344_ek1rpdsunumsistemi.xlsx",
      "sheet": "RPDH SUNUM SİSTEMİ",
      "cells": [
        "AD12"
      ]
    }
  },
  {
    "id": "consultancy_other_ihmal_istismar",
    "officialLabel": "İhmal, İstismar",
    "mebbisCode": null,
    "serviceDomain": "support",
    "category": "consultancy_other",
    "categoryLabel": "Müşavirlik / Diğer Kişilere Yönelik",
    "audience": "other",
    "developmentArea": null,
    "schoolLevel": null,
    "workMode": "group",
    "targetLinked": false,
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "workbook": "08120344_ek1rpdsunumsistemi.xlsx",
      "sheet": "RPDH SUNUM SİSTEMİ",
      "cells": [
        "AD13"
      ]
    }
  },
  {
    "id": "consultancy_other_iletisim_becerileri",
    "officialLabel": "İletişim Becerileri",
    "mebbisCode": null,
    "serviceDomain": "support",
    "category": "consultancy_other",
    "categoryLabel": "Müşavirlik / Diğer Kişilere Yönelik",
    "audience": "other",
    "developmentArea": null,
    "schoolLevel": null,
    "workMode": "group",
    "targetLinked": false,
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "workbook": "08120344_ek1rpdsunumsistemi.xlsx",
      "sheet": "RPDH SUNUM SİSTEMİ",
      "cells": [
        "AD14"
      ]
    }
  },
  {
    "id": "consultancy_other_kadina_yonelik_siddetin_onlenmesi",
    "officialLabel": "Kadına Yönelik Şiddetin Önlenmesi",
    "mebbisCode": null,
    "serviceDomain": "support",
    "category": "consultancy_other",
    "categoryLabel": "Müşavirlik / Diğer Kişilere Yönelik",
    "audience": "other",
    "developmentArea": null,
    "schoolLevel": null,
    "workMode": "group",
    "targetLinked": false,
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "workbook": "08120344_ek1rpdsunumsistemi.xlsx",
      "sheet": "RPDH SUNUM SİSTEMİ",
      "cells": [
        "AD15",
        "AD16"
      ]
    }
  },
  {
    "id": "consultancy_other_madde_bagimliligini_onleme",
    "officialLabel": "Madde Bağımlılığını Önleme",
    "mebbisCode": null,
    "serviceDomain": "support",
    "category": "consultancy_other",
    "categoryLabel": "Müşavirlik / Diğer Kişilere Yönelik",
    "audience": "other",
    "developmentArea": null,
    "schoolLevel": null,
    "workMode": "group",
    "targetLinked": false,
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "workbook": "08120344_ek1rpdsunumsistemi.xlsx",
      "sheet": "RPDH SUNUM SİSTEMİ",
      "cells": [
        "AD17"
      ]
    }
  },
  {
    "id": "consultancy_other_okula_uyum_calismalari",
    "officialLabel": "Okula Uyum Çalışmaları",
    "mebbisCode": null,
    "serviceDomain": "support",
    "category": "consultancy_other",
    "categoryLabel": "Müşavirlik / Diğer Kişilere Yönelik",
    "audience": "other",
    "developmentArea": null,
    "schoolLevel": null,
    "workMode": "group",
    "targetLinked": false,
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "workbook": "08120344_ek1rpdsunumsistemi.xlsx",
      "sheet": "RPDH SUNUM SİSTEMİ",
      "cells": [
        "AD18"
      ]
    }
  },
  {
    "id": "consultancy_other_ofke_yonetimi",
    "officialLabel": "Öfke Yönetimi",
    "mebbisCode": null,
    "serviceDomain": "support",
    "category": "consultancy_other",
    "categoryLabel": "Müşavirlik / Diğer Kişilere Yönelik",
    "audience": "other",
    "developmentArea": null,
    "schoolLevel": null,
    "workMode": "group",
    "targetLinked": false,
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "workbook": "08120344_ek1rpdsunumsistemi.xlsx",
      "sheet": "RPDH SUNUM SİSTEMİ",
      "cells": [
        "AD19"
      ]
    }
  },
  {
    "id": "consultancy_other_ozel_egitim_gereksinimli_ogrencilerin_gel_ozellikleri",
    "officialLabel": "Özel Eğitim Gereksinimli Öğrencilerin Gel.Özellikleri",
    "mebbisCode": null,
    "serviceDomain": "support",
    "category": "consultancy_other",
    "categoryLabel": "Müşavirlik / Diğer Kişilere Yönelik",
    "audience": "other",
    "developmentArea": null,
    "schoolLevel": null,
    "workMode": "group",
    "targetLinked": false,
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "workbook": "08120344_ek1rpdsunumsistemi.xlsx",
      "sheet": "RPDH SUNUM SİSTEMİ",
      "cells": [
        "AD20"
      ]
    }
  },
  {
    "id": "consultancy_other_stres_yonetimi",
    "officialLabel": "Stres Yönetimi",
    "mebbisCode": null,
    "serviceDomain": "support",
    "category": "consultancy_other",
    "categoryLabel": "Müşavirlik / Diğer Kişilere Yönelik",
    "audience": "other",
    "developmentArea": null,
    "schoolLevel": null,
    "workMode": "group",
    "targetLinked": false,
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "workbook": "08120344_ek1rpdsunumsistemi.xlsx",
      "sheet": "RPDH SUNUM SİSTEMİ",
      "cells": [
        "AD22"
      ]
    }
  },
  {
    "id": "consultancy_other_psikososyal_destek_cinsel_istismar",
    "officialLabel": "Psikososyal Destek-CİNSEL İSTİSMAR",
    "mebbisCode": null,
    "serviceDomain": "support",
    "category": "consultancy_other",
    "categoryLabel": "Müşavirlik / Diğer Kişilere Yönelik",
    "audience": "other",
    "developmentArea": null,
    "schoolLevel": null,
    "workMode": "group",
    "targetLinked": false,
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "workbook": "08120344_ek1rpdsunumsistemi.xlsx",
      "sheet": "RPDH SUNUM SİSTEMİ",
      "cells": [
        "AD23"
      ]
    }
  },
  {
    "id": "consultancy_other_psikososyal_destek_dogal_afet",
    "officialLabel": "Psikososyal Destek-DOĞAL AFET",
    "mebbisCode": null,
    "serviceDomain": "support",
    "category": "consultancy_other",
    "categoryLabel": "Müşavirlik / Diğer Kişilere Yönelik",
    "audience": "other",
    "developmentArea": null,
    "schoolLevel": null,
    "workMode": "group",
    "targetLinked": false,
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "workbook": "08120344_ek1rpdsunumsistemi.xlsx",
      "sheet": "RPDH SUNUM SİSTEMİ",
      "cells": [
        "AD25"
      ]
    }
  },
  {
    "id": "consultancy_other_psikososyal_destek_goc",
    "officialLabel": "Psikososyal Destek-GÖÇ",
    "mebbisCode": null,
    "serviceDomain": "support",
    "category": "consultancy_other",
    "categoryLabel": "Müşavirlik / Diğer Kişilere Yönelik",
    "audience": "other",
    "developmentArea": null,
    "schoolLevel": null,
    "workMode": "group",
    "targetLinked": false,
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "workbook": "08120344_ek1rpdsunumsistemi.xlsx",
      "sheet": "RPDH SUNUM SİSTEMİ",
      "cells": [
        "AD27"
      ]
    }
  },
  {
    "id": "consultancy_other_psikososyal_destek_intihar",
    "officialLabel": "Psikososyal Destek-İNTİHAR",
    "mebbisCode": null,
    "serviceDomain": "support",
    "category": "consultancy_other",
    "categoryLabel": "Müşavirlik / Diğer Kişilere Yönelik",
    "audience": "other",
    "developmentArea": null,
    "schoolLevel": null,
    "workMode": "group",
    "targetLinked": false,
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "workbook": "08120344_ek1rpdsunumsistemi.xlsx",
      "sheet": "RPDH SUNUM SİSTEMİ",
      "cells": [
        "AD28"
      ]
    }
  },
  {
    "id": "consultancy_other_psikososyal_destek_teror",
    "officialLabel": "Psikososyal Destek-TERÖR",
    "mebbisCode": null,
    "serviceDomain": "support",
    "category": "consultancy_other",
    "categoryLabel": "Müşavirlik / Diğer Kişilere Yönelik",
    "audience": "other",
    "developmentArea": null,
    "schoolLevel": null,
    "workMode": "group",
    "targetLinked": false,
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "workbook": "08120344_ek1rpdsunumsistemi.xlsx",
      "sheet": "RPDH SUNUM SİSTEMİ",
      "cells": [
        "AD29"
      ]
    }
  },
  {
    "id": "consultancy_other_psikososyal_destek_yas",
    "officialLabel": "Psikososyal Destek-YAS",
    "mebbisCode": null,
    "serviceDomain": "support",
    "category": "consultancy_other",
    "categoryLabel": "Müşavirlik / Diğer Kişilere Yönelik",
    "audience": "other",
    "developmentArea": null,
    "schoolLevel": null,
    "workMode": "group",
    "targetLinked": false,
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "workbook": "08120344_ek1rpdsunumsistemi.xlsx",
      "sheet": "RPDH SUNUM SİSTEMİ",
      "cells": [
        "AD30"
      ]
    }
  },
  {
    "id": "consultancy_other_psikolojik_saglamlik",
    "officialLabel": "Psikolojik Sağlamlık",
    "mebbisCode": null,
    "serviceDomain": "support",
    "category": "consultancy_other",
    "categoryLabel": "Müşavirlik / Diğer Kişilere Yönelik",
    "audience": "other",
    "developmentArea": null,
    "schoolLevel": null,
    "workMode": "group",
    "targetLinked": false,
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "workbook": "08120344_ek1rpdsunumsistemi.xlsx",
      "sheet": "RPDH SUNUM SİSTEMİ",
      "cells": [
        "AD31"
      ]
    }
  },
  {
    "id": "consultancy_other_saglikli_yasam",
    "officialLabel": "Sağlıklı Yaşam",
    "mebbisCode": null,
    "serviceDomain": "support",
    "category": "consultancy_other",
    "categoryLabel": "Müşavirlik / Diğer Kişilere Yönelik",
    "audience": "other",
    "developmentArea": null,
    "schoolLevel": null,
    "workMode": "group",
    "targetLinked": false,
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "workbook": "08120344_ek1rpdsunumsistemi.xlsx",
      "sheet": "RPDH SUNUM SİSTEMİ",
      "cells": [
        "AD32"
      ]
    }
  },
  {
    "id": "consultancy_other_teknoloji_bagimliligini_onleme",
    "officialLabel": "Teknoloji Bağımlılığını Önleme",
    "mebbisCode": null,
    "serviceDomain": "support",
    "category": "consultancy_other",
    "categoryLabel": "Müşavirlik / Diğer Kişilere Yönelik",
    "audience": "other",
    "developmentArea": null,
    "schoolLevel": null,
    "workMode": "group",
    "targetLinked": false,
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "workbook": "08120344_ek1rpdsunumsistemi.xlsx",
      "sheet": "RPDH SUNUM SİSTEMİ",
      "cells": [
        "AD33"
      ]
    }
  },
  {
    "id": "consultancy_other_tutun_bagimliligini_onleme",
    "officialLabel": "Tütün Bağımlılığını Önleme",
    "mebbisCode": null,
    "serviceDomain": "support",
    "category": "consultancy_other",
    "categoryLabel": "Müşavirlik / Diğer Kişilere Yönelik",
    "audience": "other",
    "developmentArea": null,
    "schoolLevel": null,
    "workMode": "group",
    "targetLinked": false,
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "workbook": "08120344_ek1rpdsunumsistemi.xlsx",
      "sheet": "RPDH SUNUM SİSTEMİ",
      "cells": [
        "AD34"
      ]
    }
  },
  {
    "id": "program_management_arastirma_calismalari",
    "officialLabel": "Araştırma Çalışmaları",
    "mebbisCode": null,
    "serviceDomain": "support",
    "category": "program_management",
    "categoryLabel": "Program Yönetimi, Araştırma, Proje",
    "audience": null,
    "developmentArea": null,
    "schoolLevel": null,
    "workMode": "group",
    "targetLinked": false,
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "workbook": "08120344_ek1rpdsunumsistemi.xlsx",
      "sheet": "RPDH SUNUM SİSTEMİ",
      "cells": [
        "AE8"
      ]
    }
  },
  {
    "id": "program_management_bep_dosyalarinin_duzenlenmesi_ve_guncellenmesi",
    "officialLabel": "BEP Dosyalarının Düzenlenmesi ve Güncellenmesi",
    "mebbisCode": null,
    "serviceDomain": "support",
    "category": "program_management",
    "categoryLabel": "Program Yönetimi, Araştırma, Proje",
    "audience": null,
    "developmentArea": null,
    "schoolLevel": null,
    "workMode": "group",
    "targetLinked": false,
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "workbook": "08120344_ek1rpdsunumsistemi.xlsx",
      "sheet": "RPDH SUNUM SİSTEMİ",
      "cells": [
        "AE9"
      ]
    }
  },
  {
    "id": "program_management_okul_risk_haritasinin_olusturulmasi",
    "officialLabel": "Okul Risk Haritasının Oluşturulması",
    "mebbisCode": null,
    "serviceDomain": "support",
    "category": "program_management",
    "categoryLabel": "Program Yönetimi, Araştırma, Proje",
    "audience": null,
    "developmentArea": null,
    "schoolLevel": null,
    "workMode": "group",
    "targetLinked": false,
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "workbook": "08120344_ek1rpdsunumsistemi.xlsx",
      "sheet": "RPDH SUNUM SİSTEMİ",
      "cells": [
        "AE11"
      ]
    }
  },
  {
    "id": "program_management_okul_kurum_rpd_programinin_hazirlanmasi",
    "officialLabel": "Okul/Kurum RPD Programının Hazırlanması",
    "mebbisCode": null,
    "serviceDomain": "support",
    "category": "program_management",
    "categoryLabel": "Program Yönetimi, Araştırma, Proje",
    "audience": null,
    "developmentArea": null,
    "schoolLevel": null,
    "workMode": "group",
    "targetLinked": false,
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "workbook": "08120344_ek1rpdsunumsistemi.xlsx",
      "sheet": "RPDH SUNUM SİSTEMİ",
      "cells": [
        "AE13"
      ]
    }
  },
  {
    "id": "program_management_proje_calismalari",
    "officialLabel": "Proje Çalışmaları",
    "mebbisCode": null,
    "serviceDomain": "support",
    "category": "program_management",
    "categoryLabel": "Program Yönetimi, Araştırma, Proje",
    "audience": null,
    "developmentArea": null,
    "schoolLevel": null,
    "workMode": "group",
    "targetLinked": false,
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "workbook": "08120344_ek1rpdsunumsistemi.xlsx",
      "sheet": "RPDH SUNUM SİSTEMİ",
      "cells": [
        "AE15"
      ]
    }
  },
  {
    "id": "program_management_ram_rpd_hizmetleri_bolumu_yillik_calisma_plani_hazirlama",
    "officialLabel": "RAM RPD Hizmetleri Bölümü Yıllık Çalışma Planı Hazırlama",
    "mebbisCode": null,
    "serviceDomain": "support",
    "category": "program_management",
    "categoryLabel": "Program Yönetimi, Araştırma, Proje",
    "audience": null,
    "developmentArea": null,
    "schoolLevel": null,
    "workMode": "group",
    "targetLinked": false,
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "workbook": "08120344_ek1rpdsunumsistemi.xlsx",
      "sheet": "RPDH SUNUM SİSTEMİ",
      "cells": [
        "AE16"
      ]
    }
  },
  {
    "id": "program_management_ram_rpd_hizmetleri_bolumu_toplantilari",
    "officialLabel": "RAM RPD Hizmetleri Bölümü Toplantıları",
    "mebbisCode": null,
    "serviceDomain": "support",
    "category": "program_management",
    "categoryLabel": "Program Yönetimi, Araştırma, Proje",
    "audience": null,
    "developmentArea": null,
    "schoolLevel": null,
    "workMode": "group",
    "targetLinked": false,
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "workbook": "08120344_ek1rpdsunumsistemi.xlsx",
      "sheet": "RPDH SUNUM SİSTEMİ",
      "cells": [
        "AE18"
      ]
    }
  },
  {
    "id": "program_management_ram_bolge_risk_haritasinin_olusturulmasi",
    "officialLabel": "RAM Bölge Risk Haritasının Oluşturulması",
    "mebbisCode": null,
    "serviceDomain": "support",
    "category": "program_management",
    "categoryLabel": "Program Yönetimi, Araştırma, Proje",
    "audience": null,
    "developmentArea": null,
    "schoolLevel": null,
    "workMode": "group",
    "targetLinked": false,
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "workbook": "08120344_ek1rpdsunumsistemi.xlsx",
      "sheet": "RPDH SUNUM SİSTEMİ",
      "cells": [
        "AE20"
      ]
    }
  },
  {
    "id": "program_management_ram_riba_bolge_sonuc_cizelgesinin_olusturulmasi",
    "officialLabel": "RAM RİBA-Bölge Sonuç Çizelgesinin Oluşturulması",
    "mebbisCode": null,
    "serviceDomain": "support",
    "category": "program_management",
    "categoryLabel": "Program Yönetimi, Araştırma, Proje",
    "audience": null,
    "developmentArea": null,
    "schoolLevel": null,
    "workMode": "group",
    "targetLinked": false,
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "workbook": "08120344_ek1rpdsunumsistemi.xlsx",
      "sheet": "RPDH SUNUM SİSTEMİ",
      "cells": [
        "AE22"
      ]
    }
  },
  {
    "id": "program_management_rehberlik_ve_psik_danisma_servisi_desimali_olusturulmasi",
    "officialLabel": "Rehberlik ve Psik.Danışma Servisi Desimali Oluşturulması",
    "mebbisCode": null,
    "serviceDomain": "support",
    "category": "program_management",
    "categoryLabel": "Program Yönetimi, Araştırma, Proje",
    "audience": null,
    "developmentArea": null,
    "schoolLevel": null,
    "workMode": "group",
    "targetLinked": false,
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "workbook": "08120344_ek1rpdsunumsistemi.xlsx",
      "sheet": "RPDH SUNUM SİSTEMİ",
      "cells": [
        "AE24",
        "AE25"
      ]
    }
  },
  {
    "id": "program_management_rehberlik_ve_psk_danisma_servisi_ihtiyaclarinin_belirlenmesi",
    "officialLabel": "Rehberlik ve Psk. Danışma Servisi İhtiyaçlarının Belirlenmesi",
    "mebbisCode": null,
    "serviceDomain": "support",
    "category": "program_management",
    "categoryLabel": "Program Yönetimi, Araştırma, Proje",
    "audience": null,
    "developmentArea": null,
    "schoolLevel": null,
    "workMode": "group",
    "targetLinked": false,
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "workbook": "08120344_ek1rpdsunumsistemi.xlsx",
      "sheet": "RPDH SUNUM SİSTEMİ",
      "cells": [
        "AE26"
      ]
    }
  },
  {
    "id": "program_management_rpdh_yurutme_komisyonu_rpd_ihtiyac_analizinin_yap",
    "officialLabel": "RPDH Yürütme Komisyonu- RPD İhtiyaç Analizinin Yap.",
    "mebbisCode": null,
    "serviceDomain": "support",
    "category": "program_management",
    "categoryLabel": "Program Yönetimi, Araştırma, Proje",
    "audience": null,
    "developmentArea": null,
    "schoolLevel": null,
    "workMode": "group",
    "targetLinked": false,
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "workbook": "08120344_ek1rpdsunumsistemi.xlsx",
      "sheet": "RPDH SUNUM SİSTEMİ",
      "cells": [
        "AE28",
        "AE29"
      ]
    }
  },
  {
    "id": "program_management_rpd_hizmetleri_yurutme_komisyonunun_olusturulmasi",
    "officialLabel": "RPD Hizmetleri Yürütme Komisyonunun Oluşturulması",
    "mebbisCode": null,
    "serviceDomain": "support",
    "category": "program_management",
    "categoryLabel": "Program Yönetimi, Araştırma, Proje",
    "audience": null,
    "developmentArea": null,
    "schoolLevel": null,
    "workMode": "group",
    "targetLinked": false,
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "workbook": "08120344_ek1rpdsunumsistemi.xlsx",
      "sheet": "RPDH SUNUM SİSTEMİ",
      "cells": [
        "AE30"
      ]
    }
  },
  {
    "id": "program_management_rpdh_yurutme_komisyonu_toplantisinin_yapilmasi",
    "officialLabel": "RPDH Yürütme Komisyonu Toplantısının Yapılması",
    "mebbisCode": null,
    "serviceDomain": "support",
    "category": "program_management",
    "categoryLabel": "Program Yönetimi, Araştırma, Proje",
    "audience": null,
    "developmentArea": null,
    "schoolLevel": null,
    "workMode": "group",
    "targetLinked": false,
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "workbook": "08120344_ek1rpdsunumsistemi.xlsx",
      "sheet": "RPDH SUNUM SİSTEMİ",
      "cells": [
        "AE32"
      ]
    }
  },
  {
    "id": "cooperation_meetings_bep_gelistirme_birimi_toplantilari",
    "officialLabel": "BEP Geliştirme Birimi Toplantıları",
    "mebbisCode": null,
    "serviceDomain": "support",
    "category": "cooperation_meetings",
    "categoryLabel": "İşbirliği / Toplantılar",
    "audience": null,
    "developmentArea": null,
    "schoolLevel": null,
    "workMode": "group",
    "targetLinked": false,
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "workbook": "08120344_ek1rpdsunumsistemi.xlsx",
      "sheet": "RPDH SUNUM SİSTEMİ",
      "cells": [
        "AF8"
      ]
    }
  },
  {
    "id": "cooperation_meetings_degerler_egitimi_komisyonu_toplantilari",
    "officialLabel": "Değerler Eğitimi Komisyonu Toplantıları",
    "mebbisCode": null,
    "serviceDomain": "support",
    "category": "cooperation_meetings",
    "categoryLabel": "İşbirliği / Toplantılar",
    "audience": null,
    "developmentArea": null,
    "schoolLevel": null,
    "workMode": "group",
    "targetLinked": false,
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "workbook": "08120344_ek1rpdsunumsistemi.xlsx",
      "sheet": "RPDH SUNUM SİSTEMİ",
      "cells": [
        "AF10"
      ]
    }
  },
  {
    "id": "cooperation_meetings_destek_egitim_odasi_toplantilari",
    "officialLabel": "Destek Eğitim Odası Toplantıları",
    "mebbisCode": null,
    "serviceDomain": "support",
    "category": "cooperation_meetings",
    "categoryLabel": "İşbirliği / Toplantılar",
    "audience": null,
    "developmentArea": null,
    "schoolLevel": null,
    "workMode": "group",
    "targetLinked": false,
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "workbook": "08120344_ek1rpdsunumsistemi.xlsx",
      "sheet": "RPDH SUNUM SİSTEMİ",
      "cells": [
        "AF12"
      ]
    }
  },
  {
    "id": "cooperation_meetings_okul_aile_birligi_toplantilari",
    "officialLabel": "Okul Aile Birliği Toplantıları",
    "mebbisCode": null,
    "serviceDomain": "support",
    "category": "cooperation_meetings",
    "categoryLabel": "İşbirliği / Toplantılar",
    "audience": null,
    "developmentArea": null,
    "schoolLevel": null,
    "workMode": "group",
    "targetLinked": false,
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "workbook": "08120344_ek1rpdsunumsistemi.xlsx",
      "sheet": "RPDH SUNUM SİSTEMİ",
      "cells": [
        "AF14"
      ]
    }
  },
  {
    "id": "cooperation_meetings_okul_psikososyal_destek_hizmetleri_ekibi_toplantilari",
    "officialLabel": "Okul Psikososyal Destek Hizmetleri Ekibi Toplantıları",
    "mebbisCode": null,
    "serviceDomain": "support",
    "category": "cooperation_meetings",
    "categoryLabel": "İşbirliği / Toplantılar",
    "audience": null,
    "developmentArea": null,
    "schoolLevel": null,
    "workMode": "group",
    "targetLinked": false,
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "workbook": "08120344_ek1rpdsunumsistemi.xlsx",
      "sheet": "RPDH SUNUM SİSTEMİ",
      "cells": [
        "AF15"
      ]
    }
  },
  {
    "id": "cooperation_meetings_ram_sene_basi_sonu_toplantilari",
    "officialLabel": "RAM Sene Başı/Sonu Toplantıları",
    "mebbisCode": null,
    "serviceDomain": "support",
    "category": "cooperation_meetings",
    "categoryLabel": "İşbirliği / Toplantılar",
    "audience": null,
    "developmentArea": null,
    "schoolLevel": null,
    "workMode": "group",
    "targetLinked": false,
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "workbook": "08120344_ek1rpdsunumsistemi.xlsx",
      "sheet": "RPDH SUNUM SİSTEMİ",
      "cells": [
        "AF17"
      ]
    }
  },
  {
    "id": "cooperation_meetings_ram_mesleki_paylasim_toplantilari",
    "officialLabel": "RAM Mesleki Paylaşım Toplantıları",
    "mebbisCode": null,
    "serviceDomain": "support",
    "category": "cooperation_meetings",
    "categoryLabel": "İşbirliği / Toplantılar",
    "audience": null,
    "developmentArea": null,
    "schoolLevel": null,
    "workMode": "group",
    "targetLinked": false,
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "workbook": "08120344_ek1rpdsunumsistemi.xlsx",
      "sheet": "RPDH SUNUM SİSTEMİ",
      "cells": [
        "AF19"
      ]
    }
  },
  {
    "id": "cooperation_meetings_ram_psikososyal_destek_hizmetleri_ekibi_toplantilari",
    "officialLabel": "RAM Psikososyal Destek Hizmetleri Ekibi Toplantıları",
    "mebbisCode": null,
    "serviceDomain": "support",
    "category": "cooperation_meetings",
    "categoryLabel": "İşbirliği / Toplantılar",
    "audience": null,
    "developmentArea": null,
    "schoolLevel": null,
    "workMode": "group",
    "targetLinked": false,
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "workbook": "08120344_ek1rpdsunumsistemi.xlsx",
      "sheet": "RPDH SUNUM SİSTEMİ",
      "cells": [
        "AF21"
      ]
    }
  },
  {
    "id": "cooperation_meetings_sinif_basari_degerlendirme_toplantilari",
    "officialLabel": "Sınıf Başarı Değerlendirme Toplantıları",
    "mebbisCode": null,
    "serviceDomain": "support",
    "category": "cooperation_meetings",
    "categoryLabel": "İşbirliği / Toplantılar",
    "audience": null,
    "developmentArea": null,
    "schoolLevel": null,
    "workMode": "group",
    "targetLinked": false,
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "workbook": "08120344_ek1rpdsunumsistemi.xlsx",
      "sheet": "RPDH SUNUM SİSTEMİ",
      "cells": [
        "AF23",
        "AF24"
      ]
    }
  },
  {
    "id": "cooperation_meetings_sube_ogretmenler_kurulu_toplantilari",
    "officialLabel": "Şube Öğretmenler Kurulu Toplantıları",
    "mebbisCode": null,
    "serviceDomain": "support",
    "category": "cooperation_meetings",
    "categoryLabel": "İşbirliği / Toplantılar",
    "audience": "teacher",
    "developmentArea": null,
    "schoolLevel": null,
    "workMode": "group",
    "targetLinked": false,
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "workbook": "08120344_ek1rpdsunumsistemi.xlsx",
      "sheet": "RPDH SUNUM SİSTEMİ",
      "cells": [
        "AF25"
      ]
    }
  },
  {
    "id": "cooperation_meetings_veli_toplantilari",
    "officialLabel": "Veli Toplantıları",
    "mebbisCode": null,
    "serviceDomain": "support",
    "category": "cooperation_meetings",
    "categoryLabel": "İşbirliği / Toplantılar",
    "audience": "parent",
    "developmentArea": null,
    "schoolLevel": null,
    "workMode": "group",
    "targetLinked": false,
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "workbook": "08120344_ek1rpdsunumsistemi.xlsx",
      "sheet": "RPDH SUNUM SİSTEMİ",
      "cells": [
        "AF27"
      ]
    }
  },
  {
    "id": "cooperation_meetings_il_rpd_hizmetleri_yurutme_komisyonu_toplantilari",
    "officialLabel": "İl RPD Hizmetleri Yürütme Komisyonu Toplantıları",
    "mebbisCode": null,
    "serviceDomain": "support",
    "category": "cooperation_meetings",
    "categoryLabel": "İşbirliği / Toplantılar",
    "audience": null,
    "developmentArea": null,
    "schoolLevel": null,
    "workMode": "group",
    "targetLinked": false,
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "workbook": "08120344_ek1rpdsunumsistemi.xlsx",
      "sheet": "RPDH SUNUM SİSTEMİ",
      "cells": [
        "AF28"
      ]
    }
  },
  {
    "id": "cooperation_meetings_diger_kurum_kurulus_toplantilari",
    "officialLabel": "Diğer Kurum/Kuruluş Toplantıları",
    "mebbisCode": null,
    "serviceDomain": "support",
    "category": "cooperation_meetings",
    "categoryLabel": "İşbirliği / Toplantılar",
    "audience": null,
    "developmentArea": null,
    "schoolLevel": null,
    "workMode": "group",
    "targetLinked": false,
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "workbook": "08120344_ek1rpdsunumsistemi.xlsx",
      "sheet": "RPDH SUNUM SİSTEMİ",
      "cells": [
        "AF30"
      ]
    }
  },
  {
    "id": "cooperation_activities_aile_katilimi_calismalari",
    "officialLabel": "Aile Katılımı Çalışmaları",
    "mebbisCode": null,
    "serviceDomain": "support",
    "category": "cooperation_activities",
    "categoryLabel": "İşbirliği / Faaliyetler",
    "audience": null,
    "developmentArea": null,
    "schoolLevel": null,
    "workMode": "group",
    "targetLinked": false,
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "workbook": "08120344_ek1rpdsunumsistemi.xlsx",
      "sheet": "RPDH SUNUM SİSTEMİ",
      "cells": [
        "AG8"
      ]
    }
  },
  {
    "id": "cooperation_activities_belirli_gun_ve_haftalar_ile_ilgili_calismalar",
    "officialLabel": "Belirli Gün ve Haftalar İle İlgili Çalışmalar",
    "mebbisCode": null,
    "serviceDomain": "support",
    "category": "cooperation_activities",
    "categoryLabel": "İşbirliği / Faaliyetler",
    "audience": null,
    "developmentArea": null,
    "schoolLevel": null,
    "workMode": "group",
    "targetLinked": false,
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "workbook": "08120344_ek1rpdsunumsistemi.xlsx",
      "sheet": "RPDH SUNUM SİSTEMİ",
      "cells": [
        "AG9"
      ]
    }
  },
  {
    "id": "cooperation_activities_degerler_egitimi_calismalari",
    "officialLabel": "Değerler Eğitimi Çalışmaları",
    "mebbisCode": null,
    "serviceDomain": "support",
    "category": "cooperation_activities",
    "categoryLabel": "İşbirliği / Faaliyetler",
    "audience": null,
    "developmentArea": null,
    "schoolLevel": null,
    "workMode": "group",
    "targetLinked": false,
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "workbook": "08120344_ek1rpdsunumsistemi.xlsx",
      "sheet": "RPDH SUNUM SİSTEMİ",
      "cells": [
        "AG11"
      ]
    }
  },
  {
    "id": "cooperation_activities_egitim_kurumunun_tanitimi",
    "officialLabel": "Eğitim Kurumunun Tanıtımı",
    "mebbisCode": null,
    "serviceDomain": "support",
    "category": "cooperation_activities",
    "categoryLabel": "İşbirliği / Faaliyetler",
    "audience": null,
    "developmentArea": null,
    "schoolLevel": null,
    "workMode": "group",
    "targetLinked": false,
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "workbook": "08120344_ek1rpdsunumsistemi.xlsx",
      "sheet": "RPDH SUNUM SİSTEMİ",
      "cells": [
        "AG12"
      ]
    }
  },
  {
    "id": "cooperation_activities_mezuniyet",
    "officialLabel": "Mezuniyet",
    "mebbisCode": null,
    "serviceDomain": "support",
    "category": "cooperation_activities",
    "categoryLabel": "İşbirliği / Faaliyetler",
    "audience": null,
    "developmentArea": null,
    "schoolLevel": null,
    "workMode": "group",
    "targetLinked": false,
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "workbook": "08120344_ek1rpdsunumsistemi.xlsx",
      "sheet": "RPDH SUNUM SİSTEMİ",
      "cells": [
        "AG13"
      ]
    }
  },
  {
    "id": "cooperation_activities_saglik_tarama_calismalari",
    "officialLabel": "Sağlık Tarama Çalışmaları",
    "mebbisCode": null,
    "serviceDomain": "support",
    "category": "cooperation_activities",
    "categoryLabel": "İşbirliği / Faaliyetler",
    "audience": null,
    "developmentArea": null,
    "schoolLevel": null,
    "workMode": "group",
    "targetLinked": false,
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "workbook": "08120344_ek1rpdsunumsistemi.xlsx",
      "sheet": "RPDH SUNUM SİSTEMİ",
      "cells": [
        "AG14"
      ]
    }
  },
  {
    "id": "cooperation_activities_yesilay_klubuyle_is_birligi",
    "officialLabel": "Yeşilay Klübüyle İş birliği",
    "mebbisCode": null,
    "serviceDomain": "support",
    "category": "cooperation_activities",
    "categoryLabel": "İşbirliği / Faaliyetler",
    "audience": null,
    "developmentArea": null,
    "schoolLevel": null,
    "workMode": "group",
    "targetLinked": false,
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "workbook": "08120344_ek1rpdsunumsistemi.xlsx",
      "sheet": "RPDH SUNUM SİSTEMİ",
      "cells": [
        "AG15"
      ]
    }
  },
  {
    "id": "professional_development_bilimsel_kongreye_katilma",
    "officialLabel": "Bilimsel Kongreye Katılma",
    "mebbisCode": null,
    "serviceDomain": "support",
    "category": "professional_development",
    "categoryLabel": "Mesleki Gelişim",
    "audience": null,
    "developmentArea": null,
    "schoolLevel": null,
    "workMode": "group",
    "targetLinked": false,
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "workbook": "08120344_ek1rpdsunumsistemi.xlsx",
      "sheet": "RPDH SUNUM SİSTEMİ",
      "cells": [
        "AH8"
      ]
    }
  },
  {
    "id": "professional_development_bilimsel_seminer_konferansa_katilma",
    "officialLabel": "Bilimsel Seminer, Konferansa Katılma",
    "mebbisCode": null,
    "serviceDomain": "support",
    "category": "professional_development",
    "categoryLabel": "Mesleki Gelişim",
    "audience": null,
    "developmentArea": null,
    "schoolLevel": null,
    "workMode": "group",
    "targetLinked": false,
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "workbook": "08120344_ek1rpdsunumsistemi.xlsx",
      "sheet": "RPDH SUNUM SİSTEMİ",
      "cells": [
        "AH9"
      ]
    }
  },
  {
    "id": "professional_development_danisman_ogretmenlik_staj_uygulamalari",
    "officialLabel": "Danışman Öğretmenlik (Staj Uygulamaları)",
    "mebbisCode": null,
    "serviceDomain": "support",
    "category": "professional_development",
    "categoryLabel": "Mesleki Gelişim",
    "audience": "teacher",
    "developmentArea": null,
    "schoolLevel": null,
    "workMode": "group",
    "targetLinked": false,
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "workbook": "08120344_ek1rpdsunumsistemi.xlsx",
      "sheet": "RPDH SUNUM SİSTEMİ",
      "cells": [
        "AH11"
      ]
    }
  },
  {
    "id": "professional_development_hizmetici_egitim_verme",
    "officialLabel": "Hizmetiçi Eğitim Verme",
    "mebbisCode": null,
    "serviceDomain": "support",
    "category": "professional_development",
    "categoryLabel": "Mesleki Gelişim",
    "audience": null,
    "developmentArea": null,
    "schoolLevel": null,
    "workMode": "group",
    "targetLinked": false,
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "workbook": "08120344_ek1rpdsunumsistemi.xlsx",
      "sheet": "RPDH SUNUM SİSTEMİ",
      "cells": [
        "AH13"
      ]
    }
  },
  {
    "id": "professional_development_hizmetici_egitime_katilma",
    "officialLabel": "Hizmetiçi Eğitime Katılma",
    "mebbisCode": null,
    "serviceDomain": "support",
    "category": "professional_development",
    "categoryLabel": "Mesleki Gelişim",
    "audience": null,
    "developmentArea": null,
    "schoolLevel": null,
    "workMode": "group",
    "targetLinked": false,
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "workbook": "08120344_ek1rpdsunumsistemi.xlsx",
      "sheet": "RPDH SUNUM SİSTEMİ",
      "cells": [
        "AH14"
      ]
    }
  },
  {
    "id": "professional_development_seminer_konferans_vb_duzenleme",
    "officialLabel": "Seminer, Konferans vb. Düzenleme",
    "mebbisCode": null,
    "serviceDomain": "support",
    "category": "professional_development",
    "categoryLabel": "Mesleki Gelişim",
    "audience": null,
    "developmentArea": null,
    "schoolLevel": null,
    "workMode": "group",
    "targetLinked": false,
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "workbook": "08120344_ek1rpdsunumsistemi.xlsx",
      "sheet": "RPDH SUNUM SİSTEMİ",
      "cells": [
        "AH15"
      ]
    }
  },
  {
    "id": "professional_development_yardim_edene_yardim_destek_gruplari",
    "officialLabel": "Yardım Edene Yardım (Destek Grupları)",
    "mebbisCode": null,
    "serviceDomain": "support",
    "category": "professional_development",
    "categoryLabel": "Mesleki Gelişim",
    "audience": null,
    "developmentArea": null,
    "schoolLevel": null,
    "workMode": "group",
    "targetLinked": false,
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "workbook": "08120344_ek1rpdsunumsistemi.xlsx",
      "sheet": "RPDH SUNUM SİSTEMİ",
      "cells": [
        "AH17"
      ]
    }
  },
  {
    "id": "professional_development_yuksek_lisans_doktora_dersine_katilma",
    "officialLabel": "Yüksek Lisans Doktora Dersine Katılma",
    "mebbisCode": null,
    "serviceDomain": "support",
    "category": "professional_development",
    "categoryLabel": "Mesleki Gelişim",
    "audience": null,
    "developmentArea": null,
    "schoolLevel": null,
    "workMode": "group",
    "targetLinked": false,
    "active": true,
    "source": {
      "system": "RPDH_SUNUM_SISTEMI",
      "workbook": "08120344_ek1rpdsunumsistemi.xlsx",
      "sheet": "RPDH SUNUM SİSTEMİ",
      "cells": [
        "AH19"
      ]
    }
  }
];

export const getAdditionalGroupActivityById = (activityId) => {
  return (
    ADDITIONAL_GROUP_ACTIVITY_CATALOG.find(
      activity => activity.id === activityId && activity.active
    ) || null
  );
};

export const getAdditionalGroupActivitiesByCategory = (category) => {
  return ADDITIONAL_GROUP_ACTIVITY_CATALOG.filter(
    activity =>
      activity.active &&
      (!category || activity.category === category)
  );
};

export const getAdditionalGroupActivityOptions = ({
  category = null,
  search = ""
} = {}) => {
  const normalizedSearch = search
    .toLocaleLowerCase("tr-TR")
    .trim();

  return ADDITIONAL_GROUP_ACTIVITY_CATALOG.filter(activity => {
    if (!activity.active) return false;

    if (category && activity.category !== category) {
      return false;
    }

    if (!normalizedSearch) return true;

    return [
      activity.officialLabel,
      activity.mebbisCode,
      activity.categoryLabel
    ]
      .filter(Boolean)
      .some(value =>
        String(value)
          .toLocaleLowerCase("tr-TR")
          .includes(normalizedSearch)
      );
  });
};
